(function(){
  var cab=document.getElementById('sj-cab'); if(!cab) return;
  var suave=true; try{ suave=!window.matchMedia('(prefers-reduced-motion: reduce)').matches; }catch(e){}

  var bar=cab.querySelector('[data-sj-ann]');
  if(bar){
    var it=bar.querySelectorAll('[data-sj-ann-item]'), n=0, t=null;
    var ver=function(k){ for(var j=0;j<it.length;j++){ if(j===k){it[j].classList.add('is-on');} else {it[j].classList.remove('is-on');} } };
    var go=function(){ if(!suave||it.length<2||t) return; t=setInterval(function(){ n=(n+1)%it.length; ver(n); },4500); };
    var stop=function(){ if(t){clearInterval(t);t=null;} };
    ver(0); go();
    bar.addEventListener('mouseenter',stop); bar.addEventListener('mouseleave',go);
  }

  var accs=cab.querySelectorAll('details.sj-dacc');
  function abrirAcc(d){
    var m=d.querySelector('.sj-dacc-m'); if(!m) return;
    d.open=true; d.classList.add('is-abierto');
    if(!suave){ m.style.height='auto'; return; }
    m.style.height='0px';
    requestAnimationFrame(function(){ m.style.height=m.scrollHeight+'px'; });
  }
  function cerrarAcc(d){
    var m=d.querySelector('.sj-dacc-m'); if(!m) return;
    d.classList.remove('is-abierto');
    if(!suave){ d.open=false; m.style.height='0px'; return; }
    m.style.height=m.scrollHeight+'px';
    requestAnimationFrame(function(){ m.style.height='0px'; });
    var fin=function(){ d.open=false; m.removeEventListener('transitionend',fin); };
    m.addEventListener('transitionend',fin);
  }
  for(var a=0;a<accs.length;a++){
    (function(d){
      d.querySelector('summary').addEventListener('click',function(ev){
        ev.preventDefault();
        if(d.open){ cerrarAcc(d); return; }
        for(var k=0;k<accs.length;k++){ if(accs[k]!==d&&accs[k].open) cerrarAcc(accs[k]); }
        abrirAcc(d);
      });
    })(accs[a]);
  }

  var bur=cab.querySelector('[data-sj-burger]'), caj=cab.querySelector('[data-sj-drawer]');
  if(bur&&caj){
    var abierto=false;
    function abreCajon(){
      abierto=true; bur.classList.add('is-x'); bur.setAttribute('aria-expanded','true');
      if(!suave){ caj.style.height='auto'; return; }
      caj.style.height='0px';
      requestAnimationFrame(function(){ caj.style.height=caj.scrollHeight+'px'; });
      var fin=function(){ if(abierto) caj.style.height='auto'; caj.removeEventListener('transitionend',fin); };
      caj.addEventListener('transitionend',fin);
    }
    function cierraCajon(){
      abierto=false; bur.classList.remove('is-x'); bur.setAttribute('aria-expanded','false');
      for(var k=0;k<accs.length;k++){ if(accs[k].open) cerrarAcc(accs[k]); }
      if(!suave){ caj.style.height='0px'; return; }
      caj.style.height=caj.offsetHeight+'px';
      requestAnimationFrame(function(){ caj.style.height='0px'; });
    }
    bur.addEventListener('click',function(ev){
      ev.stopPropagation();
      if(abierto){ cierraCajon(); } else { abreCajon(); }
    });
    caj.addEventListener('click',function(ev){ if(ev.target.closest('a')) cierraCajon(); });
    document.addEventListener('click',function(ev){
      if(!abierto) return;
      if(!caj.contains(ev.target)&&!bur.contains(ev.target)) cierraCajon();
    });
    document.addEventListener('keydown',function(ev){ if(ev.key==='Escape'&&abierto) cierraCajon(); });
  }

  var drops=cab.querySelectorAll('.sj-drop');
  function cerrarMenus(){
    for(var k=0;k<drops.length;k++){
      drops[k].classList.remove('is-open');
      var b=drops[k].querySelector('.sj-drop-t'); if(b) b.setAttribute('aria-expanded','false');
    }
  }
  for(var q=0;q<drops.length;q++){ drops[q].addEventListener('mouseenter',cerrarMenus); }
  document.addEventListener('click',function(ev){
    if(!ev.target||!ev.target.closest) return;
    var bt=ev.target.closest('#sj-cab .sj-drop-t');
    if(bt){
      var cj=bt.parentNode, ab=cj.classList.contains('is-open');
      cerrarMenus();
      if(!ab){ cj.classList.add('is-open'); bt.setAttribute('aria-expanded','true'); }
      return;
    }
    if(!ev.target.closest('#sj-cab .sj-drop')) cerrarMenus();
  });
  document.addEventListener('keydown',function(ev){ if(ev.key==='Escape') cerrarMenus(); });

  function pinta(k){
    var b=cab.querySelector('[data-sj-cart-count]'); if(!b) return;
    b.textContent=k;
    if(k>0){ b.removeAttribute('hidden'); } else { b.setAttribute('hidden',''); }
  }
  function refresca(){
    fetch('/cart.js',{headers:{'Accept':'application/json'},credentials:'same-origin'})
      .then(function(r){return r.json();}).then(function(c){ pinta(c.item_count); }).catch(function(){});
  }
  document.addEventListener('click',function(ev){
    if(ev.target&&ev.target.closest&&ev.target.closest('[data-sj-add]')){
      setTimeout(refresca,600); setTimeout(refresca,1600);
    }
  },true);
  window.addEventListener('pageshow',refresca);
})();
